import React, {useState} from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function InputNumber({
                                        fieldName,
                                        fieldValue,
                                        prefix,
                                        placeholder,
                                        error,
                                        attr,
                                        inputConstraints,
                                        onChange
                                    }) {
    const {t} = usePolTranslation();
    const {step, ...restAttr} = attr ?? {};
    const scale = (step?.toString().split('.')[1] ?? '').length;
    const [showStepWarning, setShowStepWarning] = useState(false);

    const handleChange = ({currentTarget: {value}}) => {
        if (step != null && step < 1 && value !== '') {
            const decimalsValueLength = (value.toString().split('.')[1] ?? '').length;
            setShowStepWarning(decimalsValueLength > scale);
        } else {
            setShowStepWarning(false);
        }
        onChange(value);
    }

    return (
        <>
            <input className={`input-field${error ? ' has-error' : ''}`}
                   type="number"
                   data-name={fieldName}
                   id={prefix + fieldName}
                   value={fieldValue ?? ''}
                   placeholder={placeholder}
                   data-is-required={!!inputConstraints?.required}
                   {...(inputConstraints?.min && {min: inputConstraints.min.value})}
                   {...(inputConstraints?.max && {max: inputConstraints.max.value})}
                   {...(step && {step})}
                   {...restAttr}
                   onChange={handleChange}/>
            {showStepWarning && <p className="inpu-field__tip">{t('number_type_rounded', {value: (Math.round(fieldValue / step) * step).toFixed(scale)})}</p>}
        </>
    )
}
